/* DAYLY Kids quiz funnel. Built by Lone Star Agency. */
(function () {
  'use strict';
  var current = 0;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function steps() { return $$('[data-krq-step]'); }

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }

  function wake(step) {
    if (!step) return;
    $$('img[loading="lazy"]', step).forEach(function (img) { img.loading = 'eager'; });
  }

  function renderProgress(total, index) {
    var bar = $('[data-krq-progress]');
    if (!bar) return;
    if (bar.children.length !== total) {
      bar.innerHTML = '';
      for (var k = 0; k < total; k++) { var s = document.createElement('span'); s.appendChild(document.createElement('i')); bar.appendChild(s); }
    }
    Array.prototype.forEach.call(bar.children, function (s, k) { s.classList.toggle('is-done', k <= index); });
  }

  function show(index, opts) {
    opts = opts || {};
    var list = steps();
    if (!list.length) return;
    index = Math.max(0, Math.min(list.length - 1, index));
    current = index;
    list.forEach(function (s, k) {
      var on = k === index;
      s.classList.toggle('is-active', on);
      if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
      else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
    });
    renderProgress(list.length, index);
    var back = $('[data-krq-back]'); if (back) back.hidden = index === 0;
    var skip = $('[data-krq-skip]'); if (skip) skip.hidden = index === list.length - 1;
    wake(list[index]); wake(list[index + 1]);
    if (opts.push) { try { history.pushState({ krq: index }, '', '#step-' + (index + 1)); } catch (e) {} }
    if (!opts.noScroll) window.scrollTo(0, 0);
    if (opts.focus) {
      var h = $('.krq-h', list[index]);
      if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }
    if (list[index].hasAttribute('data-krq-offer') && !opts.silent) setTimeout(confetti, 180);
    initReviews(list[index]);
    track('krq_step_view', { step: index + 1, total: list.length });
  }

  function go(index) { show(index, { push: true, focus: true }); }

  // ---------- reviews carousel ----------
  // Transform-based slider: swipe on touch, drag with a mouse, arrows, dots and autoplay.
  function initReviews(step) {
    var wrap = $('[data-krq-reviews]', step);
    if (!wrap) return;
    if (wrap._krq) { wrap._krq.resume(); return; }
    var track = $('[data-krq-reviews-track]', wrap), dots = $('[data-krq-dots]', wrap);
    var prev = $('[data-krq-prev]', wrap), next = $('[data-krq-next-review]', wrap);
    var cards = $$('.krq-review', track), n = cards.length, i = 0, dx = 0, gap = 12;
    var timer = null, touched = false, drag = null, moved = 0;

    if (!track.parentNode.classList.contains('krq-reviews__viewport')) {
      var vp = document.createElement('div'); vp.className = 'krq-reviews__viewport';
      track.parentNode.insertBefore(vp, track); vp.appendChild(track);
    }
    var nav = $('.krq-reviews__nav', wrap);
    if (n < 2) { if (nav) nav.hidden = true; return; }

    dots.innerHTML = '';
    cards.forEach(function (c, k) {
      c.setAttribute('aria-roledescription', 'slide');
      c.setAttribute('aria-label', (k + 1) + ' of ' + n);
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Show review ' + (k + 1));
      b.addEventListener('click', function () { stop(); goTo(k); });
      dots.appendChild(b);
    });

    function width() { return track.parentNode.clientWidth; }
    function render(animate) {
      track.style.transition = animate && !reduceMotion ? 'transform .45s cubic-bezier(.2,.7,.2,1)' : 'none';
      track.style.transform = 'translate3d(' + (-i * (width() + gap) + dx) + 'px,0,0)';
      Array.prototype.forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      cards.forEach(function (c, k) { if (k === i) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true'); });
    }
    function goTo(k) { i = (k + n) % n; dx = 0; render(true); }
    function stop() { touched = true; if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (reduceMotion || touched || timer) return;
      timer = setInterval(function () {
        if (!step.classList.contains('is-active') || document.hidden) return;
        goTo(i + 1);
      }, 5000);
    }

    prev.addEventListener('click', function () { stop(); goTo(i - 1); });
    next.addEventListener('click', function () { stop(); goTo(i + 1); });

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag = { x: e.clientX, y: e.clientY, id: e.pointerId, axis: null, t: Date.now() };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var mx = e.clientX - drag.x, my = e.clientY - drag.y;
      if (drag.axis === null) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        drag.axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (drag.axis === 'x') { stop(); try { track.setPointerCapture(e.pointerId); } catch (err) {} track.classList.add('is-dragging'); }
      }
      if (drag.axis !== 'x') return;
      e.preventDefault();
      dx = mx; render(false);
    });
    function end(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      if (drag.axis === 'x') {
        var fast = Math.abs(dx) > 20 && Date.now() - drag.t < 250;
        var limit = Math.min(60, width() * 0.18);
        if (dx < -limit || (fast && dx < 0)) goTo(i + 1);
        else if (dx > limit || (fast && dx > 0)) goTo(i - 1);
        else goTo(i);
        moved = Date.now();
      }
      track.classList.remove('is-dragging');
      drag = null;
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('lostpointercapture', end);
    track.addEventListener('click', function (e) { if (Date.now() - moved < 300) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { stop(); goTo(i - 1); }
      if (e.key === 'ArrowRight') { stop(); goTo(i + 1); }
    });
    window.addEventListener('resize', function () { render(false); });

    wrap._krq = { resume: function () { render(false); start(); } };
    render(false);
    start();
  }

  // ---------- confetti ----------
  function confetti() {
    var c = $('[data-krq-confetti]');
    if (!c || c.dataset.off === 'true' || reduceMotion || !c.getContext) return;
    var ctx = c.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = window.innerWidth, H = window.innerHeight;
    c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    c.style.display = 'block';
    var colors = ['#FF8A1E', '#F6EF9A', '#8B78D8', '#5FC6C0', '#FF6B8B', '#FFFFFF', '#FFC94D'];
    var parts = [], n = W < 600 ? 150 : 220;
    for (var k = 0; k < n; k++) {
      var left = k % 2 === 0;
      parts.push({
        x: left ? -10 : W + 10, y: H * (0.55 + Math.random() * 0.2),
        vx: (left ? 1 : -1) * (4 + Math.random() * (W < 600 ? 9 : 14)),
        vy: -(11 + Math.random() * 13),
        g: 0.28 + Math.random() * 0.1, drag: 0.982 + Math.random() * 0.01,
        w: 6 + Math.random() * 6, h: 9 + Math.random() * 8,
        r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.35,
        wob: Math.random() * 6.28, c: colors[k % colors.length], shape: k % 4
      });
    }
    var start = null;
    function frame(t) {
      if (start === null) start = t;
      var el = t - start, alive = 0;
      ctx.clearRect(0, 0, W, H);
      var fade = el > 2600 ? Math.max(0, 1 - (el - 2600) / 900) : 1;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.vx *= p.drag; p.vy = p.vy * p.drag + p.g; p.wob += 0.12;
        p.x += p.vx + Math.sin(p.wob) * 0.6; p.y += p.vy; p.r += p.vr;
        if (p.y > H + 30) continue;
        alive++;
        ctx.save(); ctx.globalAlpha = fade; ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c;
        if (p.shape === 0) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, 6.283); ctx.fill(); }
        else { ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * (0.35 + Math.abs(Math.cos(p.wob)) * 0.65)); }
        ctx.restore();
      }
      if (alive && el < 3600) requestAnimationFrame(frame);
      else { ctx.clearRect(0, 0, W, H); c.style.display = 'none'; }
    }
    requestAnimationFrame(frame);
    track('krq_offer_view', {});
  }

  // ---------- offer ----------
  function syncOffer(form) {
    var r = $('input[name="id"]:checked', form);
    $$('.krq-opt', form).forEach(function (o) { o.classList.toggle('is-selected', !!$('input:checked', o)); });
    if (!r) return;
    var plan = $('[data-krq-plan]', form);
    if (plan) { plan.value = r.dataset.plan || ''; plan.disabled = !r.dataset.plan; }
    var save = $('[data-krq-save]', form.parentNode);
    if (save) save.textContent = r.dataset.save || '';
  }

  function submitOffer(form) {
    var r = $('input[name="id"]:checked', form);
    var btn = $('[data-krq-claim]', form), err = $('[data-krq-error]', form);
    if (!r) { if (err) { err.textContent = 'Please pick a set first.'; err.hidden = false; } return; }
    if (!window.fetch) { form.submit(); return; }
    var item = { id: Number(r.value), quantity: 1 };
    if (r.dataset.plan) item.selling_plan = Number(r.dataset.plan);
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    track('krq_claim', { variant_id: item.id, selling_plan: item.selling_plan || null });
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw new Error(json.description || json.message || 'Something went wrong.');
        return json;
      });
    }).then(function () {
      var to = form.dataset.redirect || '/checkout';
      if (typeof window.krqBeforeRedirect === 'function' && window.krqBeforeRedirect(to) === false) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); return; }
      window.location.href = to.charAt(0) === '/' ? root + to.slice(1) : to;
    }).catch(function (e) {
      btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      if (err) { err.textContent = (e && e.message) || 'Something went wrong. Please try again.'; err.hidden = false; }
    });
  }

  // ---------- events ----------
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-krq-next]')) { e.preventDefault(); go(current + 1); return; }
    if (t.closest('[data-krq-skip]')) { e.preventDefault(); track('krq_skip', { from: current + 1 }); go(steps().length - 1); return; }
    if (t.closest('[data-krq-back]')) {
      e.preventDefault();
      if (history.state && typeof history.state.krq === 'number' && history.state.krq > 0) history.back();
      else show(current - 1, { focus: true });
    }
  });
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-krq-form]');
    if (form) syncOffer(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-krq-form]');
    if (!form) return;
    e.preventDefault();
    submitOffer(form);
  });
  window.addEventListener('popstate', function (e) {
    var i = e.state && typeof e.state.krq === 'number' ? e.state.krq : 0;
    show(i, {});
  });

  // Theme editor: open the step that is being edited.
  document.addEventListener('shopify:section:select', function (e) {
    var list = steps();
    for (var k = 0; k < list.length; k++) if (list[k].dataset.sectionId === e.detail.sectionId) { show(k, { silent: true, noScroll: true }); return; }
  });
  document.addEventListener('shopify:section:load', function () { init(true); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(function () { init(true); }, 0); });

  function init(keep) {
    $$('[data-krq-form]').forEach(syncOffer);
    var start = keep ? current : 0;
    if (!keep) {
      var m = /^#step-(\d+)$/.exec(window.location.hash);
      if (m) start = Number(m[1]) - 1;
      else if (window.location.hash === '#offer') start = steps().length - 1;
      try { history.replaceState({ krq: start }, '', window.location.href); } catch (e) {}
    }
    show(start, { noScroll: !!keep, silent: !!(window.Shopify && Shopify.designMode) });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(false); });
  else init(false);
})();
